<template>
  <div id="app">
    <header>
      <router-link to="/">
        <img
          @mouseenter="onLinkMouseEnter"
          @mouseleave="onLinkMouseLeave"
          class="logo"
          src="../static/images/logo/logo-white.svg"
          alt="Logo Davy Jacquemard"
        />
      </router-link>
      <nav class="navigation">
        <ul>
          <router-link to="/">
            <li @mouseenter="onLinkMouseEnter" @mouseleave="onLinkMouseLeave">HOME</li>
          </router-link>
          <router-link to="/projets">
            <li @mouseenter="onLinkMouseEnter" @mouseleave="onLinkMouseLeave">PROJETS</li>
          </router-link>
          <router-link to="/a-propos">
            <li @mouseenter="onLinkMouseEnter" @mouseleave="onLinkMouseLeave">À PROPOS</li>
          </router-link>
        </ul>
      </nav>
    </header>

    <router-view />
    <div class="cursor">
      <div class="cursor__inner cursor__inner--circle"></div>
      <div class="cursor__inner cursor__inner--dot"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      tooLarge: false
    };
  },
  methods: {
    initGlobalCursor() {
      var getMousePos = function getMousePos(e) {
        var posx = 0;
        var posy = 0;
        if (!e) e = window.event;

        if (e.pageX || e.pageY) {
          posx = e.pageX;
          posy = e.pageY;
        } else if (e.clientX || e.clientY) {
          posx =
            e.clientX + body.scrollLeft + document.documentElement.scrollLeft;
          posy =
            e.clientY + body.scrollTop + document.documentElement.scrollTop;
        }

        return {
          x: posx,
          y: posy
        };
      };

      const lerp = (a, b, n) => (1 - n) * a + n * b;
      var DOM = {
        el: document.querySelector(".cursor"),
        dot: document.querySelector(".cursor__inner--dot"),
        circle: document.querySelector(".cursor__inner--circle")
      };
      var bounds = {
        dot: DOM.dot.getBoundingClientRect(),
        circle: DOM.circle.getBoundingClientRect()
      };
      var scale = 1;
      var opacity = 1;
      var mousePos = { x: 0, y: 0 };
      var lastMousePos = { dot: { x: 0, y: 0 }, circle: { x: 0, y: 0 } };
      var lastScale = 1;
      var lastOpacity = 1;

      function initEvents() {
        window.addEventListener("mousemove", function(ev) {
          return (mousePos = getMousePos(ev));
        });
      }
      var render = function render() {
        lastMousePos.dot.x = lerp(
          lastMousePos.dot.x,
          mousePos.x - bounds.dot.width / 2,
          1
        );
        lastMousePos.dot.y = lerp(
          lastMousePos.dot.y,
          mousePos.y - bounds.dot.height / 2,
          1
        );
        lastMousePos.circle.x = lerp(
          lastMousePos.circle.x,
          mousePos.x - bounds.circle.width / 2,
          0.15
        );
        lastMousePos.circle.y = lerp(
          lastMousePos.circle.y,
          mousePos.y - bounds.circle.height / 2,
          0.15
        );
        lastScale = lerp(lastScale, scale, 0.15);
        lastOpacity = lerp(lastOpacity, opacity, 0.1);
        DOM.dot.style.transform = `translateX(${lastMousePos.dot.x}px) translateY(${lastMousePos.dot.y}px)`;
        DOM.circle.style.transform = `translateX(${lastMousePos.circle.x}px) translateY(${lastMousePos.circle.y}px) scale(${lastScale})`;
        DOM.circle.style.opacity = lastOpacity;
        requestAnimationFrame(render);
      };
      initEvents();
      requestAnimationFrame(render);
    },
    onLinkMouseEnter() {
      if (window.innerWidth > 980) {
        var cursorCircle = document.querySelector(".cursor__inner--circle");
        cursorCircle.classList.add("cursor-animate");
        TweenMax.to(cursorCircle, 0.3, {
          width: 60 + "px",
          height: 60 + "px",
          top: -20 + "px",
          left: -20 + "px",
          ease: "back.out(1.7)"
        });
      }
    },
    onLinkMouseLeave() {
      if (window.innerWidth > 980) {
        var cursorCircle = document.querySelector(".cursor__inner--circle");
        cursorCircle.classList.remove("cursor-animate");
        TweenMax.to(cursorCircle, 0.3, {
          width: 20,
          height: 20,
          top: 0,
          left: 0,
          ease: "back.out(1.7)"
        });
      }
    }
  },
  mounted() {
    if (window.innerWidth > 980) {
      this.initGlobalCursor();
      this.tooLarge = true;
    }
  }
};
</script>

<style lang='scss'>
@import url("./assets/css/global.scss");
$break-medium: 768px;
$break-large: 1260px;
.cursor {
  @media screen and (max-width: $break-medium) {
    display: none;
  }
}

.cursor__inner {
  z-index: 9999;
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 50%;
}
.cursor__inner--dot {
  width: 6px;
  height: 6px;
  background: #fff;
}
.cursor__inner--circle {
  width: 20px;
  height: 20px;
  border: 1px solid #fff;
}
header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 62px;
  z-index: 999;
  background-color: #0e0d10;

  a.router-link-exact-active {
    //  color: #ae5242;
    // transform: translateX(100%);
    //transition: transform 1s ease;
    font-weight: 700;
    li::after {
      transform: translateX(0) !important;
      transition: transform 1s cubic-bezier(0.75, 0.01, 0.62, 1.52) !important;
    }
  }

  .logo {
    position: absolute;
    height: 40px;
    left: 20px;
    top: 50%;
    transform: translateY(-50%);
    overflow: hidden;
    @media screen and (min-width: $break-medium) {
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
    }
  }

  .navigation {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 16px;
    width: 75vw;
    left: calc(25vw - 16px);
    font-family: "Uni Sans", sans-serif;
    letter-spacing: 4px;
    font-size: 1.2rem;
    @media screen and (min-width: $break-medium) {
      width: 40vw;
      left: calc(60vw - 16px);
      font-size: 1.4rem;
    }
    @media screen and (min-width: $break-large) {
      width: 25vw;
      left: calc(75vw - 16px);
    }

    ul {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      mix-blend-mode: difference;

      li {
        overflow: hidden;
        padding: 10px 0;
        position: relative;
        &::after {
          content: "";
          position: absolute;
          width: 80%;
          margin-top: 9px;
          opacity: 0.8;
          height: 10px;
          left: 0;
          z-index: -1;
          background-color: #ea5242;
          transform: translateX(-102%);
          transition: transform 1s cubic-bezier(0.75, 0.01, 0.62, 1.52);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue